/**
 * socialEffects.js — Social Effect Executors (4 types)
 *
 * Ally-targeting effects. These do NOT mutate context.character —
 * they return allyUpdates for the caller to broadcast via
 * PartyBroadcastService.
 *
 * Requires userInput.allyId for targeting. ActionExecutor returns
 * 'awaiting_input' if allyId is missing.
 *
 * Part of the Composable Mechanic Engine (Issue #82, Phase A: #175)
 */

import { resolveExpression } from '../expressions';

// ─── Social Effect Executors ────────────────────────────────────────────────

export const SOCIAL_EFFECT_EXECUTORS = {
  /**
   * Heal an ally's HP.
   * effect: { type: 'heal_ally', amount? }
   */
  heal_ally: (effect, context) => {
    const amount = resolveExpression(effect.amount || 1, context);
    return {
      characterMutated: false,
      allyUpdates: [{
        type: 'heal',
        amount,
        targetAllyId: context.userInput?.allyId || null,
      }],
    };
  },

  /**
   * Clear stress from an ally.
   * effect: { type: 'clear_ally_stress', amount? }
   */
  clear_ally_stress: (effect, context) => {
    const amount = resolveExpression(effect.amount || 1, context);
    return {
      characterMutated: false,
      allyUpdates: [{
        type: 'clear_stress',
        amount,
        targetAllyId: context.userInput?.allyId || null,
      }],
    };
  },

  /**
   * Grant hope to an ally.
   * effect: { type: 'grant_ally_hope', amount? }
   */
  grant_ally_hope: (effect, context) => {
    const amount = resolveExpression(effect.amount || 1, context);
    return {
      characterMutated: false,
      allyUpdates: [{
        type: 'grant_hope',
        amount,
        targetAllyId: context.userInput?.allyId || null,
      }],
    };
  },

  /**
   * Grant temporary armor to an ally.
   * effect: { type: 'grant_ally_armor', amount?, expiresOn? }
   */
  grant_ally_armor: (effect, context) => {
    const amount = resolveExpression(effect.amount || 1, context);
    return {
      characterMutated: false,
      allyUpdates: [{
        type: 'grant_armor',
        amount,
        expiresOn: effect.expiresOn || 'rest',
        targetAllyId: context.userInput?.allyId || null,
      }],
    };
  },
};
